import style from './FormComp.module.css';
import Select, { components } from 'react-select';

const FormComp = ({
    title,
    titleHover,
    type,
    options,
    mapped,
    valor,
    changeFunc,
    readOnly,
    disabled,
    maxLength,
    placeholder,
    required,
    name,
    multiple,
    obj
}) => {

    const ValueContainer = ({ children, ...props }) => {
        let [values, input] = children;
        if (Array.isArray(values)) {
            const plural = values.length === 1 ? "" : "S";
            values = `${values.length} SELECIONADO${plural}`;
        }

        return (
            <components.ValueContainer {...props}>
                {values}
                {input}
            </components.ValueContainer>
        );
    };

    // 🔢 Função para tratar entradas numéricas
    const handleInputChange = (e) => {
        let newValue = e.target.value;

        if (type === "numberOnly") {
            newValue = newValue.replace(/\D/g, ""); // remove tudo que não for número
        }

        // Repassa o evento padronizado para o pai
        changeFunc({ target: { name, value: newValue } });
    };

    return (
        <div className={style.formChild}>
            <p title={titleHover}>{title}</p>

            {type === 'select' ? (
                <select
                    style={disabled ? { backgroundColor: "white", color: "black", opacity: 1 } : {}}
                    value={valor}
                    onChange={changeFunc}
                    disabled={disabled || readOnly }
                    required={required}
                    name={name}
                    multiple={multiple}
                >
                    <option value="">SELECIONE...</option>

                    {mapped ? (
                        options
                    ) : obj ? (
                        options.map((opt) => (
                            <option value={opt.value} key={opt.value}>
                                {opt.label}
                            </option>
                        ))
                    ) : (
                        options.map((opt, index) => (
                            <option value={opt} key={index}>
                                {opt}
                            </option>
                        ))
                    )}
                </select>

            ) : type === 'textarea' ? (
                <textarea
                    value={valor}
                    onChange={changeFunc}
                    disabled={disabled}
                    required={required}
                    name={name}
                    readOnly={readOnly}
                />
            ) : type === 'multiselect' ? (
                <Select
                    placeholder={placeholder}
                    value={valor}
                    options={options}
                    isClearable
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{ ValueContainer }}
                    onChange={changeFunc}
                    required={required}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minHeight: '40px',
                            height: '40px',
                            borderColor: state.isFocused ? '#2563eb' : '#94a3b8',
                            boxShadow: state.isFocused ? '0 0 0 1px #2563eb' : 'none',
                            borderRadius: '8px',
                            '&:hover': {
                                borderColor: '#2563eb'
                            },
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            height: '40px',
                            padding: '0 13px',
                            fontSize: '13px',
                        }),
                        input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                        }),
                        indicatorsContainer: (base) => ({
                            ...base,
                            height: '40px',
                        }),
                    }}
                />
            ) : (
                <input
                    type={type === "numberOnly" ? "text" : type}
                    value={valor}
                    onChange={handleInputChange}
                    readOnly={readOnly}
                    disabled={disabled}
                    maxLength={maxLength}
                    placeholder={placeholder}
                    required={required}
                    name={name}
                    multiple={multiple}
                    inputMode={type === "numberOnly" ? "numeric" : undefined}
                    pattern={type === "numberOnly" ? "[0-9]*" : undefined}
                />
            )}
        </div>
    );
};

export default FormComp;